import api from '../api'
import {
  libraryLoadSucceeded,
  libraryLoadFailed,
  libraryExpectedCount,
  libraryLoadBegin,
} from './libraryLoadStatus'

// Shared load path for the collections assembled from own + allRepos.
//
// Full load and refresh used to be two helpers that differed only in the success
// action and where the count came from. A delta's x-total-count is the number of
// changed records, so refresh still has to recount the collection separately.
export function fetchLibraryCollection(dispatch, {
  collection, request, url, successType, modifiedAfter,
}) {
  dispatch(libraryLoadBegin(collection, request))
  if (modifiedAfter) {
    api.batchedFetch(`${url}&modifiedAfter=${modifiedAfter}`)
      .then((response) => {
        dispatch({ type: successType, response })
        dispatch(libraryLoadSucceeded(collection, request, null))
      })
      .catch(() => { dispatch(libraryLoadFailed(collection, request)) })
    api.countFetch(url)
      .then((totalCount) => { dispatch(libraryExpectedCount(collection, request, totalCount)) })
      .catch(() => {})
    return
  }
  api.batchedFetchWithMeta(url)
    .then(({ items, totalCount }) => {
      dispatch({ type: successType, response: items })
      dispatch(libraryLoadSucceeded(collection, request, totalCount))
    })
    .catch(() => { dispatch(libraryLoadFailed(collection, request)) })
}

// Convenience for today's two-slice load. Each slice begins itself, so a
// future own-only caller can use fetchLibraryCollection directly.
export function fetchLibraryPair(dispatch, {
  collection, urls, successType, modifiedAfter,
}) {
  fetchLibraryCollection(dispatch, {
    collection, request: 'own', url: urls.own, successType, modifiedAfter,
  })
  fetchLibraryCollection(dispatch, {
    collection, request: 'allRepos', url: urls.allRepos, successType, modifiedAfter,
  })
}
